import React, { useState, useEffect } from 'react'
import CreatableSelect from 'react-select/creatable'
import { CalendarIcon } from '../../../../_components'
import styles from '../../styles.module.scss'

export const intervalQueryPosfix = {
  "A": 31536000,
  "M": 2592000,
  "D": 86400,
  "h": 3600,
  "m": 60,
  "s": 1
}

export default function Interval({localData, setLocalData, disabled = false}) {
  const handleChange = (e, type) => {
    const arr = localData.trigger || []
    const raw = `raw_${type}`

    if ( e === null ) {
      return setLocalData( {
        ...localData,
        trigger: {
          ...localData.trigger,
          [type]: null
        },
        [raw]: e
      } )
    }

    if ( !e || !type ) {
      delete arr.dischargeIn
      return setLocalData({...localData, trigger: arr}, {[raw]: []})
    }

    const values = e.map(({value}) => {
      const multi = intervalQueryPosfix

      const regex = value.match(/[a-z]+|[^a-z]+/gi);
      const multiValue = regex[0];
      const multiplier = multi[regex[1]];
      const totalSeconds = multiplier * multiValue;

      if ( !multiplier ) return void 0

      return totalSeconds
    })

    setLocalData({...localData, trigger: {...arr, [type]: values}, [raw]: e})
  }

  return (<>
    <div className="flex__break"></div>

    <section className={styles['card__sub-body']}>
      <div className={styles['title__group']}>
        <CalendarIcon/>
        <h3>Intervalo de notificação</h3>
        <span className="help" data-help="O intervalo de notificação define em qual momento sua base será impactada após realizar as ações que as encaixem no filtro. Para definir o período, utilize as expressões D para dia, h para horas, m para minutos e s para segundos. Exemplo: 1D 2h 3s">?</span>
      </div>
      <CreatableSelect
        isDisabled={disabled}
        className={`selectable ${styles['selectable__interval']}`}
        value={localData.raw_dischargeIn}
        isClearable
        isMulti
        placeholder="Defina o intervalo da notificação. Exemplo: 2h 3m 10s"
        components={{DropdownIndicator: null}}
        noOptionsMessage={() => "D = Dia | h = hora | m = minuto | s = segundos"}
        formatCreateLabel={(inputValue) => `Adicionar intervalo de: ${inputValue}`}
        onChange={(e) => handleChange(e, 'dischargeIn')}
      />
    </section>
  </>)
}